import { render, staticRenderFns } from "./ScrollingTicker.vue?vue&type=template&id=73ffbb5e&scoped=true"
import script from "./ScrollingTicker.vue?vue&type=script&lang=js"
export * from "./ScrollingTicker.vue?vue&type=script&lang=js"
import style0 from "./ScrollingTicker.vue?vue&type=style&index=0&id=73ffbb5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ffbb5e",
  null
  
)

export default component.exports